import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const streamTag = style([
  typography.labelSm,
  {
    width: 'fit-content',
    height: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: space.s4,
    borderRadius: borderRadius.r4,
    padding: `${space.s6}px ${space.s8}px`,
    background: themeVars.container.secondary.background.idle,
    whiteSpace: 'nowrap',
  },
]);

globalStyle(`${streamTag} svg`, {
  width: 18,
  height: 18,
});
